import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-black relative overflow-hidden" data-id="element-93" data-mp="3uei0rbisni08">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold-dark/10 via-black to-black pointer-events-none" data-id="element-94" data-mp="c7k6g0aiwrpx"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-95" data-mp="m3wy6smicvi1">
        <div className="text-center mb-16" data-id="element-96" data-mp="h5vf47p30w6k">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-97" data-mp="h4u5m7npshqy">
            Next Monday you can keep building your classes from scratch...
            <br data-id="element-98" data-mp="qvx3l0lckgm0" />
            <span className="text-gold-gradient" data-id="element-99" data-mp="qveyrfkmcu2h">
              Or you can walk into the studio with everything ready — from
              today.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-dark-card p-8 rounded-2xl border border-dark-border" data-id="element-100" data-mp="zwmw9vfb9qvi">
            {['No more Sunday nights searching for sequences that work', 'No more classes that feel rushed or improvised', 'No more students who lose motivation because the sessions feel repetitive', 'No more weekends lost planning instead of living', 'No more walking in wishing you had prepared more'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-101" data-mp="2v2r4jnmwtq9t" data-mpi={i}>
                <span className="text-gold mt-1" data-id="element-102" data-mp="302c5u4pjyapp">▸</span>
                <span className="text-gray-300" data-id="element-103" data-mp="300so09o8zrlt">{item}</span>
              </div>)}
          </div>

          <p className="text-xl text-white mb-2" data-id="element-104" data-mp="34veymami9g4u">
            Yoga Teacher Ready™ does not make you a better teacher.
          </p>
          <p className="text-2xl font-bold text-gold mb-6" data-id="element-105" data-mp="3errsp9lypw04">
            You are already a great teacher.
          </p>
          <p className="text-xl text-gray-300 mb-16" data-id="element-106" data-mp="3isbrehm6p7od">
            What Yoga Teacher Ready™ does is give you the time and the tools to
            make that visible in every single class you teach.
          </p>
        </div>

        <div className="bg-black border-2 border-gold/30 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(212,175,55,0.1)]" data-id="element-107" data-mp="1eqtkjg8wwr5n">
          <h3 className="text-2xl font-bold text-white mb-6 text-center border-b border-dark-border pb-6" data-id="element-108" data-mp="1sirntafxzstw">
            Everything that is included:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-109" data-mp="22djju9tvm7mk">
            {['120 Ready-to-Teach Yoga Classes', '9 yoga class categories', '40+ weeks without repeating', 'Every class fully structured', 'Scripts, cues & transitions included', 'Bonus 1 — 52 Weekly Teaching Themes', 'Bonus 2 — Ultimate Cueing Library', 'Bonus 3 — Beginner Modification Guide', 'Bonus 4 — 30 Emergency Classes', 'Bonus 5 — Class Finder System', '7-day money-back guarantee', 'Immediate access', 'Pay in your local currency', 'Ready-to-use PDF format'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-110" data-mp="3pc2kp37vh1w4" data-mpi={i}>
                <Check size={18} className="text-gold shrink-0" data-id="element-111" data-mp="3p9q3wtduoxkn" />
                <span className="text-sm text-gray-200" data-id="element-112" data-mp="3u9cf6xa4c3qt">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-113" data-mp="3fc1ztcucudpt">
            <div className="mb-8 p-6 bg-gold/5 rounded-xl border border-gold/20 italic text-gray-300 text-lg" data-id="element-114" data-mp="3kczdbc4f6jkz">
              "The best time to have this teaching library was before your very
              first class.
              <br data-id="element-115" data-mp="3bct3q1bue3r3" />
              <span className="text-gold font-bold not-italic" data-id="element-116" data-mp="3bcbaldkh85ne">
                The second-best time is today.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold text-white mb-2" data-id="element-117" data-mp="19ky4il6rvrpr">
              📚 Yoga Teacher Ready™
            </p>
            <p className="text-sm text-gray-400 mb-8" data-id="element-118" data-mp="35m8dct632ryv">
              120 ready-to-teach yoga classes created to help teachers plan
              less, teach with confidence, and keep every session fresh.
            </p>

            <Button href="https://yoga-teacher-ready.impultienda.ar/checkout" target="_blank" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Yoga Teacher Ready Complete Pack',
                value: 27.0,
                currency: 'USD'
              });
            }
          }} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-119" data-mp="2vnk86uz767cl">
              🟡 GET THE COMPLETE TEACHING LIBRARY NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-500" data-id="element-120" data-mp="1yyuor07x96oi">
              <span data-id="element-121" data-mp="ehliziqx0f7p">✅ 7-Day Money-Back Guarantee</span>
              <span data-id="element-122" data-mp="ej6cd51hts3z">✅ Secure Payment</span>
              <span data-id="element-123" data-mp="jfn9upul1itq">✅ Immediate Access</span>
              <span data-id="element-124" data-mp="jebwbybc4wpf">✅ Pay in Your Local Currency</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}